import { useEffect } from 'react';

const SchemaInjector = ({ schema }) => {
  useEffect(() => {
    const scriptId = 'dynamic-schema-script';
    // Remove existing script to avoid duplicates on re-render
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      // Clean up script on component unmount
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [schema]);

  return null;
};

export default SchemaInjector;
